import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <header className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md py-3 shadow-sm' : 'bg-transparent py-5'}`} data-id="element-39">
      <div className="container mx-auto px-4 md:px-6" data-id="element-40">
        <div className="flex justify-between items-center" data-id="element-41">
          <Link to="/" className="text-black font-light text-xl tracking-widest" data-id="element-42">
            LIENOV
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-10" data-id="element-43">
            <Link to="/" className={`text-sm tracking-wider hover:text-gray-500 transition-colors ${location.pathname === '/' ? 'border-b border-black pb-1' : ''}`} data-id="element-44">
              Home
            </Link>
            <Link to="/privacy-policy" className={`text-sm tracking-wider hover:text-gray-500 transition-colors ${location.pathname === '/privacy-policy' ? 'border-b border-black pb-1' : ''}`} data-id="element-45">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className={`text-sm tracking-wider hover:text-gray-500 transition-colors ${location.pathname === '/terms-of-service' ? 'border-b border-black pb-1' : ''}`} data-id="element-46">
              Terms of Service
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden text-black" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-47">
            {isMenuOpen ? <X size={24} data-id="element-48" /> : <Menu size={24} data-id="element-49" />}
          </button>
        </div>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-md" data-id="element-50">
          <div className="flex flex-col p-4 space-y-4" data-id="element-51">
            <Link to="/" className="text-sm tracking-wider py-2" onClick={() => setIsMenuOpen(false)} data-id="element-52">
              Home
            </Link>
            <Link to="/privacy-policy" className="text-sm tracking-wider py-2" onClick={() => setIsMenuOpen(false)} data-id="element-53">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="text-sm tracking-wider py-2" onClick={() => setIsMenuOpen(false)} data-id="element-54">
              Terms of Service
            </Link>
          </div>
        </div>}
    </header>;
};
export default Header;